import axios from "axios";
import React, { useEffect, useState } from "react";
import {
    FaArrowLeft
} from 'react-icons/fa'
import {useNavigate} from 'react-router-dom'
import { baseUrl } from "../../Config/URL";
import Swal from "sweetalert2";
import Sidebar from "../../components/Sidebar";
import { estateConfig } from "../../components/PageConfig";

const Unpaid = () => {
    const [dataUnpaid, setDataUnpaid] = useState([])
    const [openData, setOpenData] = useState("")
    const [tgl_bayar, setTglBayar] = useState("")
    const [isLoading, setIsLoading] = useState(false)
    const [search, setSearch] = useState("")



    useEffect(() => {
        getDataUnpaid()
    },[])

    useEffect(() => {
        loading2(isLoading)
    })

    const loading2 = () => {
        if(isLoading){
            return(
                Swal.fire({
                    icon: "info",
                    title: "Loading",
                    text: "Please Wait",
                    showConfirmButton: false,
                    showCancelButton: false,
                    allowEnterKey: false,
                    allowOutsideClick: false

                    
                })
            )
        }else{return null}
    }

    const openModalHandler = (e) => {
        const modal = document.getElementById("profile-modal")
        modal.style.display = "flex"
        console.log(e);
        setOpenData(e)
        
      }
      
    const  closeModalHandler = () => {
        document.getElementById("profile-modal").style.display = "none"
        setTglBayar("")
        setOpenData("")
      }

    const getDataUnpaid = () => {
        axios.get(baseUrl+'getunpaidinvoice')
        .then(res => {
            console.log(res.data);
            setDataUnpaid(res.data)
        })
    }

    const searchDataUnpaid = () => {
      axios.post(baseUrl+"searchdataunpaidinvoice",{
          nama:search
      })
      .then(res => {
          console.log(res.data);
          setDataUnpaid(res.data)
      }).catch(err => {
          console.log(err);
      })
  }

    const paidStatus = (e) => {
        // setIsLoading(true)
        const id = openData.id_invoice
        // console.log(id);
        // console.log(tgl_bayar);

        axios.put(baseUrl+"updatestatusinvoice", {
            tgl_bayar,
            id
        }).then(res => {
            setIsLoading(false)            
            console.log(res.data);
            Swal.fire({
                title: 'Success',
                text: res.data.msg,
                icon: 'success',
                showConfirmButton: true,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok',
                allowOutsideClick: false
              }).then((result) => {
                if (result.isConfirmed) {
                    
                    closeModalHandler()
                    setIsLoading(false)
                }
              })
            getDataUnpaid()
        }).catch(err => {
            setIsLoading(false)            

            // console.log("Err_"+isLoading);
            console.log(err);
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: err.response.data.msg,
                allowOutsideClick: false
              }).then((result) => {
                if(result.isConfirmed){
                    setIsLoading(false)                }
              })
        })
    }
    

    const generateRef = (e) => {


        let id = 0
        let tglInit = new Date()
        let tgl = tglInit.getMonth(e.created_at)+1
        let tglRoman = ""
        let year = tglInit.getFullYear()
  
        if(e.no_invoice < 10){
          id = "00"+e.no_invoice
        }else if(e.no_invoice >= 10 && e.no_invoice < 100){
          id = "0"+e.no_invoice
        }else{
          id = e.no_invoice
        }
  
  
        switch (tgl) {
          case 1:
            tglRoman = "I"
            break;
          case 2:
              tglRoman = "II"
            break;
          case 3:
      tglRoman = "III";
            break;
          case 4:
      tglRoman = "IV";
            break;
          case 5:
  tglRoman = "V";
            break;
          case 6:
    tglRoman = "VI";
            break;
          case 7:
    tglRoman = "VII";
            break;
          case 8:
          tglRoman = "VIII";
            break;
          case 9:
              tglRoman = "IX";
            break;
          case 10:
          tglRoman = "X";
            break;
          case 11:
            tglRoman = "XI";
            break;
          case 12:
            tglRoman = "XII";
            break;
      }
  
  
  
        // console.log(id+'/'+'GGI-INV/MR/'+tglRoman+'/'+year);
        // console.log(dataInvoice[0].id_invoice);
        const refrenceGen = id+'/'+'GGI-INV/MR/'+tglRoman+'/'+year
        // setRefrence(id+'/'+'GGI-INV/MR/'+tglRoman+'/'+year)
        return refrenceGen
  
      }
    const navigate = useNavigate()

    return(
      <Sidebar menuItems={estateConfig}>
        <main id="unit-main" >
                <div className="unit-container" >
                    <FaArrowLeft className='arrow-back' size={25} onClick={() => {navigate(`/estate`)}} />
                    <h4>Mazenta Residence</h4>
                    <h2>Payment</h2>
                    <section className="search-group" >

                    <input onChange={(e) => {setSearch(e.target.value)}} type="search" placeholder="Cari No. Unit/Nama" className="search-box" />
                        <button onClick={searchDataUnpaid} className="search-button" >Cari</button>
                        <button onClick={getDataUnpaid} className="search-button" >Reset</button>

                    </section>
                    
                    <section className="list-antrian" >
                    
                        
                    <table class="greyGridTable">
                        <thead>
                        <tr>
                            <th className="no">No.</th>
                            <th>No. Invoice</th>
                            <th>Nama</th>
                            <th>Jatuh Tempo</th>
                            <th>No.Unit</th>
                      
                            
                            <th>Grand Total</th>
                            <th>Tanggal Invoice</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dataUnpaid.map((item, index) => {
                                return(
                                    <>
                                        <tr onClick={() => {openModalHandler(item)}} >
                                        <td className="no">{index+1}</td>
                                        <td>{generateRef(item)}</td>
                                        <td>{item.nama_customer}</td>
                                        <td>{item.date_due}</td>
                                        <td>{item.no_unit_invoice}</td>
                                        
                                        
                                        <td>Rp.{item.grandtotal_invoice.toLocaleString('IN')}</td>
                                        <td>{item.date_full}</td>
                                        </tr>
                                    </>
                                )
                            })}
                            {/* <tr onClick={openModalHandler} >
                                <td>1</td>
                                <td>123</td>
                                <td>asd</td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>123</td>
                                <td>asd</td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>123</td>
                                <td>asd</td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>123</td>
                                <td>asd</td>
                            </tr> */}
                        </tbody>
                    </table>
                    {dataUnpaid.length === 0 && <h3 className="no-data">Belum Ada Data</h3>}


                    {/* MODAL START */}


                    <div className = "profile-modal" id = "profile-modal" >
                <div className = "profile-modalContent" >
                  <h1>Detail Tagihan</h1>
                  <div className = "profile-editForm" >
                    
                    <label>Tanggal Bayar :  </label>
                    <input value={tgl_bayar} onChange={(e)=>{setTglBayar(e.target.value)}} type="date"   />
                    
                    <div className = "form-button" > 
                    <button onClick={(e)=>{paidStatus(e)}} className = "profile-save btn "   >Paid</button>
                    <button onClick={closeModalHandler} className = "profile-cancel  btn" id = "profile-cancel">Batalkan</button>
                    </div>
                  </div>
                </div>
        
              </div>


                    {/* MODAL END */}



                    </section>
                </div>
            </main>
            </Sidebar>
    )

}

export default Unpaid;